<template>
	<div>
    <div class="position-relative" style="z-index: 1030">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="rounded-top-6 bg-white">
                  <div class="w-100 py-2 px-2" style="box-shadow: rgb(236 236 236) 0px -1px 3px;height: 60px">
                    <div class="row slim-grid-row w-100 text-center">
                      <div class="col-3">
                        <router-link :to="'/'+getMerchant().code+'/dev/hotel/home'">
                          <img src="../../assets/img/icon/menu/icn_home_inactive.png" width="18">
                          <p class="body-3-1 font-regular mb-0 mt-2px" style="color: #c1c1c1">Home</p>
                        </router-link>
                      </div>
                      <div class="col-3">
                        <router-link :to="'/'+getMerchant().code+'/dev/hotel/hotel-history'">
                          <img src="../../assets/img/hotel/order.png" width="18">
                          <p class="body-3-1 font-regular mb-0 mt-2px" style="color: #c1c1c1">History</p>
                        </router-link>
                      </div>
                      <div class="col-3">
                        <router-link :to="'/'+getMerchant().code+'/dev/hotel/order-and-request'">
                          <img src="../../assets/img/hotel/question.png" width="18">
                          <p class="body-3-1 font-regular mb-0 mt-2px" style="color: #c1c1c1">Request</p>
                        </router-link>
                      </div>
                      <div class="col-3">
                        <router-link :to="'/'+getMerchant().code+'/account'">
                          <img src="../../assets/img/hotel/user.png" width="18">
                          <p class="body-3-1 font-regular mb-0 mt-2px" style="color: #c1c1c1">Profil</p>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import {mapGetters} from 'vuex';
  export default{
    components: {
    },
    data() {
      return{

      }
    },
    methods: {
      ...mapGetters(['getMerchant']),
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dev/Navigation.vue